<template>
  <div class="aboutUs imgTOP-current header-90" :class="{'en-font':locale=='EN'}">
     <div  class="top-img">
      <img src="../assets/images/aboutUs.png" alt="" class="mobile_hide">
       <img src="../assets/images/aboutUs-mobile.png" alt="" class="pc_hide">
      <div class="info-box">
        <div class="title-box">
          <h2>About Bafang</h2>
          <h3>{{$t("home_2")}}</h3>
        </div>
      </div>
    </div>
    <div class="about-main-bg">
      <div class="about-main">
        <div class="about-conten">
          <div class="product-title">
            <router-link to="/home">{{$t("home_0")}}</router-link>
            <em> /  </em>
            <span>{{$t("home_2")}}</span>
          </div>
          <div class="about-nav mobile_hide" :class="{'en-nav-font':locale=='EN'}">
            <ul>
              <li @click="linktop('top1')" :class="[{active : refname=='top1'}]" >{{$t("company_1")}}</li>
              <li @click="linktop('top2')" :class="[{active : refname=='top2'}]">{{$t("company_2")}}</li>
              <li @click="linktop('top3')" :class="[{active : refname=='top3'}]">{{$t("company_3")}}</li>
              <li @click="linktop('top4')" :class="[{active : refname=='top4'}]">{{$t("company_4")}}</li>
              <li @click="linktop('top5')" :class="[{active : refname=='top5'}]">{{$t("company_5")}}</li>
              <li @click="linktop('top8')" :class="[{active : refname=='top8'}]">{{$t("company_9")}}</li>
            </ul>
          </div>
          <div class="type-nav pc_hide">
            <vue-tab-select v-model="refname" v-bind:list="menuList" v-bind:title="'home_2'" v-on:valueChanged="linktop"></vue-tab-select>
          </div>
          <div ref="top1" id="top1" class="about-box-01">
            <div class="left">
              <div class="titleBox">
                <h2>Business Philosophy</h2>
                <p class="subtitle" :class="{'en_hide':locale=='EN'}">
                  <span class="line"></span>
                  <span class="subtitle-font">{{$t("company_1")}}</span>
                </p>
              </div>
              <div class="right pc_hide">
                <div class="img">
                  <img src="../assets/images/about01-mobile.png" alt="">
                </div>
              </div>
              <div class="description ">
                <h3 class="pc_hide">{{$t("company_10")}}</h3>
                <p class="en-description">{{$t("company_11")}}</p>
              </div>
            </div>
            <div class="right mobile_hide">
              <div class="img">
                <img src="../assets/images/about01.png" alt="" v-if="this.$i18n.locale === 'tw' || this.$i18n.locale === 'cn'">
                <img src="../assets/images/about01-jpa.png" alt="" v-if="this.$i18n.locale === 'jpa'">
                <img src="../assets/images/about01-en.png" alt="" v-if="this.$i18n.locale === 'en'">
              </div>
            </div>
          </div>
          <div ref="top2" id="top2">
            <div class="about-box-02">
              <div class="titleBox pc_hide">
                <h2>Food Safety Policy</h2>
                <p class="subtitle"  :class="{'en_hide':locale=='EN'}">
                  <span class="line"></span>
                  <span class="subtitle-font">{{$t("company_2")}}</span>
                </p>
              </div>
              <div class="left">
                <div class="img pc_hide">
                  <img src="../assets/images/about022.png" alt="">
                </div>
                <div class="img">
                  <img src="../assets/images/about02.png" alt="">
                </div>
                <div class="description ">
                  <p class="en-description">{{$t("company_12")}}</p>
                </div>
              </div>
              <div class="right mobile_hide">
                <div class="titleBox">
                  <h2>Food Safety Policy</h2>
                  <p class="subtitle" :class="{'en_hide':locale=='EN'}">
                    <span class="line"></span>
                    <span class="subtitle-font">{{$t("company_2")}}</span>
                  </p>
                </div>
                <div class="img-box">
                  <div class="color-bg"></div>
                  <div class="img">
                    <img src="../assets/images/about022.png" alt="">
                  </div>
                </div>

              </div>
            </div>
          </div>
          <div ref="top3" id="top3" class="about-box-03">
            <div class="left">
              <div class="titleBox">
                <h2>Quality Certification</h2>
                <p class="subtitle"  :class="{'en_hide':locale=='EN'}">
                  <span class="line"></span>
                  <span class="subtitle-font">{{$t("company_3")}}</span>
                </p>
              </div>

              <div class="right pc_hide">
                <div class="img">
                  <img src="../assets/images/about03.png" alt="">
                </div>
              </div>

              <div class="description ">
                <p class="en-description">{{$t('company_13')}}</p>
              </div>
            </div>
            <div class="right mobile_hide">
              <div class="img">
                <img src="../assets/images/about03.png" alt="">
              </div>
            </div>
          </div>
        </div>
        <div ref="top4" id="top4" class="about-box-04">
          <div class="potsticker mobile_hide">
            <img src="../assets/images/aboutTop04.png" alt="">
          </div>
          <div class="titleBox titleBox2 color-white">
            <h2>Bafang Milestones</h2>
            <p class="subtitle" :class="{'en_hide':locale=='EN'}">
              <span class="line"></span>
              <span class="subtitle-font">{{$t('company_4')}}</span>
            </p>
          </div>
          <div class="content-scroll set-scroll">
            <div class="content-box">
              <div class="milestoneBox">
                <div >
                  <img src="../assets/images/about041.png" alt="">
                  <section class="scroll-content">
                    <p class="en-description">{{$t("company_14")}}</p>
                  </section>
                </div>
                <div >
                  <img src="../assets/images/about042.png" alt="">
                  <section class="scroll-content ">
                    <p class="en-description">{{$t("company_16")}}</p>
                  </section>
                </div>
                <div >
                  <img src="../assets/images/about043.png" alt="">
                  <section class="scroll-content">
                    <p class="en-description">{{$t("company_18")}}</p>
                  </section>
                </div>
                <div >
                  <img src="../assets/images/about050.png" alt="">
                  <section class="scroll-content ">
                    <p class="en-description">{{$t("company_35")}}<br>{{$t("company_35_1")}}</p>
                  </section>
                </div>
                <div >
                  <img src="../assets/images/about052.png" alt="">
                  <section class="scroll-content ">
                    <p class="en-description">{{$t("company_37")}}<br>{{$t("company_37_1")}}</p>
                  </section>
                </div>
                <!--2025-->
                <div style="background-color: #D00717;box-shadow:none">
                  <img src="" alt="">
                  <section class="scroll-content">
                    <p class="en-description"></p>
                  </section>
                </div>
              </div>
              <div class="step-year">
                <ul>
                  <li class="actived">
                    <div class="step-content">
                      <div class="year">{{$t("company_14_0")}}</div>
                      <div class="icon"></div>
                    </div>
                  </li>
                  <li>
                    <div class="step-content">
                      <div class="year">{{$t("company_15_0")}}</div>
                      <div class="icon"></div>
                    </div>
                  </li>
                  <li>
                    <div class="step-content">
                      <div class="year">{{$t("company_16_0")}}</div>
                      <div class="icon"></div>
                    </div>
                  </li>
                  <li>
                    <div class="step-content">
                      <div class="year">{{$t("company_17_0")}}</div>
                      <div class="icon"></div>
                    </div>
                  </li>
                  <li>
                    <div class="step-content">
                      <div class="year">{{$t("company_18_0")}}</div>
                      <div class="icon"></div>
                    </div>
                  </li>
                  <li>
                    <div class="step-content">
                      <div class="year">{{$t("company_34_0")}}</div>
                      <div class="icon"></div>
                    </div>
                  </li>
                  <li>
                    <div class="step-content">
                      <div class="year">{{$t("company_35_0")}}</div>
                      <div class="icon"></div>
                    </div>
                  </li>
                  <li>
                    <div class="step-content">
                      <div class="year">{{$t("company_36_0")}}</div>
                      <div class="icon"></div>
                    </div>
                  </li>
                  <li>
                    <div class="step-content">
                      <div class="year">{{$t("company_37_0")}}</div>
                      <div class="icon"></div>
                    </div>
                  </li>
                <li>
                 <div class="step-content">
                      <div class="year">{{$t("company_39_0")}}</div>
                      <div class="icon"></div>
                    </div>
                  </li>
                  <!--2025-->
                  <li >
                 <div class="step-content" >
                      <div class="year"></div>
                      <div ></div>
                    </div>
                  </li>
                </ul>
              </div>
              <div class="milestoneBox">
                <div >
                  <img src="../assets/images/about045.png" alt="">
                  <section class="scroll-content">
                    <p class="en-description">{{$t("company_15")}}</p>
                  </section>
                </div>
                <div >
                  <img src="../assets/images/about046.png" alt="">
                  <section class="scroll-content">
                    <p class="en-description">{{$t("company_17")}}</p>
                  </section>
                </div>
                <div >
                  <img src="../assets/images/about049.png" alt="">
                  <section class="scroll-content">
                    <p class="en-description">{{$t("company_34")}}</p>
                  </section>
                </div>
                <div >
                  <img src="../assets/images/about051.png" alt="">
                  <section class="scroll-content">
                    <p class="en-description">{{$t("company_36")}}<br>{{$t("company_36_1")}}</p>
                  </section>
                </div>
            <div >
                  <img src="../assets/images/about053.png" alt="">
                  <section class="scroll-content">
                    <p class="en-description">{{$t("company_39")}}<br />{{$t("company_39_1")}}</p>
                  </section>
                </div>
              </div>
            </div>
          </div>
        </div>


        <div ref="top5" id="top5" class="about-box-05">
          <div class="leftTop mobile_hide">
            <img src="../assets/images/aboutTop1-05.png" alt="">
          </div>
          <div class="titleBox titleBox2 pt-130">
            <h2 >Bafang Regional</h2>
            <p class="subtitle "  :class="{'en_hide':locale=='EN'}">
              <span class="line"></span>
              <span class="subtitle-font">{{$t("company_5")}}</span>
            </p>
          </div>
          <div class="rightTop mobile_hide">
            <img src="../assets/images/aboutTop2-05.png" alt="">
          </div>
          <div class="milestoneBox">
            <div >
              <img src="../assets/images/about047.png" alt="">
              <section class="scroll-content">
                <p><b>{{$t("company_19_0")}}</b></p>
                <p class="en-description">{{$t("company_19_1")}}</p>
                <p class="en-description">{{$t("company_19_2")}}</p>
                <p class="en-description">{{$t("company_19_3")}}</p>
              </section>
            </div>
            <div >
              <img src="../assets/images/about048.png" alt="">
              <section class="scroll-content">
                <p><b>{{$t("company_20_0")}}</b></p>
                <p class="en-description">{{$t("company_20_1")}}</p>
                <p class="en-description">{{$t("company_20_2")}}</p>
              </section>
            </div>
            <div >
              <img src="../assets/images/about052.png" alt="">
              <section class="scroll-content">
                <p><b>{{$t("company_38_0")}}</b></p>
                <p class="en-description">{{$t("company_38_1")}}</p>
                <p class="en-description">{{$t("company_38_2")}}</p>
              </section>
            </div>
          </div>
        </div>
        <div  class="about-box-06">


          <div ref="top8" id="top8" class="about-Corporate">
            <div class="titleBox titleBox2 titleBox3 color-white text-pl-72">
              <h2>Manufacturing Location in Taiwan</h2>
              <p class="subtitle " :class="{'en_hide':locale=='EN'}">
                <span class="subtitle-font">{{$t("company_9")}}</span>
                <span class="line mobile_hide"></span>
              </p>
            </div>
            <div class="container-box potstickers-box">
              <div class="swiper-container swiper-milestoneBox" id="swiper-milestoneBox">
                <div class="swiper-wrapper milestoneBox max-milestoneBox-100">
                  <div class="swiper-slide">
                    <div >
                      <div class="img-box">
                        <img src="../assets/images/danshuiyichang.jpg" alt="">
                      </div>
                      <div class="content">
                        <div class="set-height">
                          <h3>{{ $t('company_24') }}</h3>
                          <p class="en-description">{{ $t('company_25') }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="swiper-slide">
                    <div >
                      <div class="img-box">
                        <img src="../assets/images/danshuierchang.jpg" alt="">
                      </div>
                      <div class="content">
                        <div class="set-height">
                          <h3>{{ $t('company_26') }}</h3>
                          <p class="en-description">{{ $t('company_27') }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="swiper-slide">
                    <div >
                      <div class="img-box">
                        <img src="../assets/images/xiluocaiqieshucaichang.png" alt="">
                      </div>
                      <div class="content">
                        <div class="set-height">
                          <h3>{{ $t('company_28') }}</h3>
                          <p class="en-description">{{ $t('company_29') }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="swiper-slide">
                    <div >
                      <div class="img-box">
                        <img src="../assets/images/gaoxiongyichang.jpg" alt="">
                      </div>
                      <div class="content">
                        <div class="set-height">
                          <h3>{{ $t('company_30') }}</h3>
                          <p class="en-description">{{ $t('company_31') }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="swiper-slide">
                    <div >
                      <div class="img-box">
                        <img src="../assets/images/gaoxiongerchang.jpg" alt="">
                      </div>
                      <div class="content">
                        <div class="set-height">
                          <h3>{{ $t('company_32') }}</h3>
                          <p class="en-description">{{ $t('company_33') }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="swiper-button-next" id="swiper-milestone-box-button-next"></div>
              <div class="swiper-button-prev" id="swiper-milestone-box-button-prev"></div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <my-popup v-if="isShowPopup"  v-bind:users="users" v-on:closeChanged="closePopup"></my-popup>
  </div>
</template>

<script>
import Popup from '../components/default/Popup.vue';
import vueTabSelect from '../components/default/vue-tab-select';
  export default {
    data(){
      return{
        refname:'top1',
        isShowPopup: false,
        users: [
          { name: "林欣怡", job: '董事' },
          { name: "林家鈺", job: '董事' },
          { name: "富御投資(股)公司 代表人：林明哲", job: '董事' },
          { name: "張瑞蓮", job: '董事' },
          { name: "李明山", job: '董事' },
          { name: "張明輝", job: '獨立董事' },
          { name: "饒世湛", job: '獨立董事' },
          { name: "吳昇奇", job: '獨立董事' },
          { name: "邱士芳", job: '獨立董事' }
          ],
        menuList: [
          { name: "company_1", code: 'top1' },
          { name: "company_2", code: 'top2' },
          { name: "company_3", code: 'top3' },
          { name: "company_4", code: 'top4' },
          { name: "company_5", code: 'top5' },
          { name: "company_6", code: 'top6' },
          { name: "company_8", code: 'top7' },
          { name: "company_9", code: 'top8' },
        ],
        locale:'tw'
      }
    },
    mounted() {
      this.locale=sessionStorage.getItem('lang')
      if(this.$route.params.id){
        this.linktop(this.$route.params.id)
      }
      this.$nextTick(()=>{
        this.initSwiper();
      })
      /*setTimeout(() => {

      }, 500);*/
    },
    methods: {
      linktop(refid){
        const { top } = $(`#${refid}`).offset();
        $('html , body').animate({scrollTop: top}, 'slow');
        //document.documentElement.scrollTop = this.$refs[refid].offsetTop
        this.refname = refid
      },
      initSwiper(){
        const swiper = new Swiper('#swiper-milestoneBox', {
          slidesPerView: 1,
          spaceBetween: 10,
          uniqueNavElements: false,
          navigation: {
            nextEl: '#swiper-milestone-box-button-next',
            prevEl: '#swiper-milestone-box-button-prev',
          },
          breakpoints: {
            320: {
              slidesPerView: 1,
              spaceBetween: 15,
            },
            640: {
              slidesPerView: 2,
              spaceBetween: 15,
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 15,
            },
            1024: {
              slidesPerView: 2,
              spaceBetween: 40,
            },
            1440: {
              slidesPerView: 3,
              spaceBetween: 40,
            },
          }
        });
      },
      openPopup(){
        this.isShowPopup = true;
        $('body').addClass('no-scroll');
      },
      closePopup(value){
        this.isShowPopup = value;
        $('body').removeClass('no-scroll');
      }
    },
    components:{
      'my-popup':Popup,
      'vue-tab-select': vueTabSelect
    },
    watch:{
      $route: {
        handler() {
          this.linktop(this.$route.params.id)
        },
        deep: true,
      }
    }

  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  ul{
    padding-left:0;
  }
  .en_hide{
    display: none;
  }
  .aboutUs{
    width: 100%;
    height:auto;
   .top-img{
 /*    width: 100%;
    !* height: 354px;*!
     padding-top: 19.8%;
     position: relative;
     background: #f9f9f9 url("../assets/images/aboutUs.png") no-repeat center;
     background-size: 100% 100%;*/

     .bg-img{
       position: absolute;
       width: 100%;
     }
  /*   .info-box{
       width: 100%;
       max-width: 1130px;
       padding: 0 20px;
       margin: 0 auto;
       .title-box{
         position: absolute;
         bottom:34%;
         left: 20%;
       !*  float: left;
         padding-top: 60px;*!
         text-align: right;
         h2{
           color: #FFFFFF;
           font-size: 70px;
           font-style: italic;
           font-weight: 900;
           letter-spacing: 0;
           padding-bottom: 30px;
     !*      line-height: 120px;*!
           margin: 0;
         }
         h3{
           color: #FFFFFF;
           font-size: 36px;
           letter-spacing: 1px;
           line-height: 42px;
           margin: 0;
         }
       }
     }*/
   }
  }
  .flexbox{
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
  }
  .box{
    display: inline-block;
    width: 50px;
    height: 20px;
    background: #999999;
    margin: 0 20px;
    text-align: center;
  }
  .boxtitle{
    height: 500px;
  }
  .boxcolor{
    color: red;
  }
/*  .top-img{
    width: 100%;
    height: 100%;
      img{
        width: 100%;
        height: 100%;
        background-size: cover;
      }
  }*/
  .product-title{
    padding-bottom:52px;
    font-size: 14px;
    letter-spacing: 1.5px;
    text-align: left;
    padding-left: 30px;
      a{
        color: #000;
         text-decoration: underline;
      }
      em{
        padding: 0 4px;
      }
      span,em{
        color: #9A928D;
      }
  }
  .about-main-bg{
    background:  #f9f9f9 url("../assets/images/product-contenBg2.png") no-repeat center top;
    background-size: 100% auto;
  }
  .about-main{
    width: 100%;
    height: 100%;
   /* background: url("../assets/images/product-detail-bg.png") no-repeat center top;*/
    background-size: 100% auto;
    overflow: hidden;
    padding-top: 50px;
    .about-conten{
      max-width:1480px;
      margin: 0 auto;
      padding: 0 20px;
    }
  }
  .about-nav{
    min-height: 80px;
    line-height: 80px;
    width: 100%;
    border-radius: 39px;
    background-color: #FFFFFF;
    box-shadow: 0 10px 20px 0 rgba(0,0,0,0.05);
    ul{
      width: 100%;
      margin: 0 auto;
      text-align: center;
      li{
        display: inline-block;
        font-size: 22px;
        letter-spacing: 1px;
        cursor: pointer;
        line-height: 32px;
        padding: 0 25px;
         &.active,&:hover{
            color: #D00717;
            font-weight: 500;
          }
      }

    }
  }
  .en-nav-font{
    ul{
      li{
        font-size: 20px;
        letter-spacing: 0px;
      }
    }
  }
/*  .titleBox{
     h2{
       transform: rotate(360deg);
       color: #000000;

       font-size: 40px;
       font-style: italic;
       font-weight: 900;
       padding-left: 73px;
      }
     .subtitle{
        .line{
          height: 2px;
          width: 227px;
          background: #231916;
          display: inline-block;
          vertical-align: text-top;
        }
        .subtitle-font{
          transform: rotate(360deg);
          color: #2A1C15;

          font-size: 40px;
          padding-left: 30px;
        }
     }
  }*/
  .about-box-01{
    width: 100%;
    height: auto;
    overflow: hidden;
    .titleBox {
      h2{
        margin-bottom: 13px;
      }
    }
    .left{
      width: 51.3888%;
      display: inline-block;
      box-sizing: border-box;
      padding-top: 126px;
      .description{
        margin-top: 27px;
        height: auto;
        max-width: 718px;
        border-radius: 30px;
        background-color: #FFFFFF;
        box-shadow: 0 10px 20px 0 rgba(0,0,0,0.05);
        padding: 58px 75px 63px 78px;
        margin-left: 22px;
        p{
          width:100%;
          color: #2A1C15;
          font-size: 18px;
          line-height: 32px;
          text-align: justify;
          letter-spacing: 1px;
        }
      }
    }
    .right{
      width: 43.6805%;
      display: inline-block;
      vertical-align: top;
      padding: 57px 32px 0 38px;
      &.pc_hide{
        display: none;
      }
      .img{
        max-width: 560px;
        height: auto;
        img{
          width: 100%;
          height: 100%;
          background-size: 100%;
        }
      }
    }
  }
  #top2{
    padding-top:115px;
  }
  .about-box-02{
    max-width: 1363px;
    box-sizing: border-box;
    min-height: 660px;
    border-radius: 30px;
    background-color: #FFFFFF;
    box-shadow: 0 10px 20px 0 rgba(0,0,0,0.05);
    margin-left:33px;
    overflow: visible;
    &:after{
      content: "";
      display: block;
      clear: both;
    }
    .left{
      width: 57.5935%;
      display: inline-block;
      .img{
        max-width: 785px;
        height: 424px;
        margin-top:-76px;
        margin-left:-33px;
          img{
            width: 100%;
            background-size: 100%;
          }
      }
      .description{
        max-width: 651px;
        margin: 72px auto 72px;
        padding-left: 11px;

        p{
          color: #000000;
          font-size: 18px;
          line-height: 32px;
          text-align: justify;
          letter-spacing: 1px;
        }

      }
    }
    .right{
      width: 45.6346%;
      display: inline-block;
      vertical-align: top;
      padding-top: 45px;
      margin-right: -62px;
      .titleBox {
        max-width: 515px;
        margin: 0 auto;
        h2{
          padding-left: 132px;
        }
      }
      .img{
        height: 324px;
        position: relative;
        top: 32px;
        right: 19px;
           img{
             width: 100%;
             background-size: 100%;
           }
      }
      .img-box{
        position: relative;
         margin-top:32px;

        .color-bg{
          height: 285px;
          width: 100%;
          max-width: 614px;
          border-radius: 30px;
          background-color: #D00717;
          position: absolute;
        }
      }
    }
  }
  .about-box-03{
    padding-top:146px;
    position: relative;
    .titleBox {
      .subtitle{
        .line{
          width: 164px;
        }
        .subtitle-font{
          color: #3B240F;
          font-size: 40px;
          letter-spacing: 3.33px;
          padding-left: 25px;
        }
      }
    }
    .left{
      display: inline-block;
      .titleBox{
        margin-bottom: 45px;
      }
      .description{
        min-height: 372px;
        max-width: 568px;
        border-radius: 30px;
        background-color: #FFFFFF;
        box-shadow: 0 10px 20px 0 rgba(0,0,0,0.05);
        padding:70px 185px 78px 58px;
        overflow: auto;
        margin-left: 33px;
        &::-webkit-scrollbar {
          width: 1px;
          height: 1px;
        }
        p{
          color: #000000;
          font-size: 18px;
          line-height: 32px;
          text-align: justify;
          letter-spacing: 1px;
        }
      }
    }
    .right{
      display: inline-block;
      position: absolute;
      left: 450px;
      top: 180px;
      width: calc(100% - 437px);
      .img{
        max-width:970px;
        height: 424px;
        img{
          width: 100%;
          height: 100%;
          background-size: 100%;
        }
      }
    }
  }
  .titleBox2{
    margin-left:30%;
    padding-top: 200px;
  h2{
    padding-left:0;
  }
   &.color-white{
      h2,span{
        color: #fff !important;
      }
      .line{
        background: #fff !important;
      }
    }
  }
    .titleBox222{
    margin-left:30%;
    padding-top: 50px;
  h2{
    padding-left:0;
  }
   &.color-white{
      h2,span{
        color: #fff !important;
      }
      .line{
        background: #fff !important;
      }
    }
  }
  .about-box-04{
    width: 100%;
    height: auto;
    background: url(../assets/images/about04Bg.png) no-repeat center top;
    background-size: cover;
    margin-top: 86px;
    position: relative;
    padding-bottom: 236px;
    .titleBox2{
      margin-left: 26%;
      padding-top: 265px;
    }
    .potsticker{
      width: 24%;
      height: auto;
      position: absolute;
      left: 0;
      top:-167px;
    }

    .content-box{
      width: 3600px;/*滚动条區塊寬度，原3200*/
    }
    .content-scroll{
      width: 100%;
      overflow: auto;
      padding-bottom: 8px;
      margin-bottom: 8px;
      &::-webkit-scrollbar {/*滚动条整体样式*/
        width: 10px;     /*高宽分别对应横竖滚动条的尺寸*/
        height: 10px;
      }
      &::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
        border-radius: 10px;
        background:rgba(255,255,255,0.4);
      }
      &::-webkit-scrollbar-track {/*滚动条里面轨道*/
        border-radius: 10px;
        background: none;
      }
    }

  }
  .milestoneBox{
    padding-top:91px;
    width:100%;
    height: auto;
    text-align: center;
  div{
    max-width: 540px;
    min-height: 135px;
    border-radius: 20px;
    background-color: #FFFFFF;
    box-shadow: 0 10px 20px 0 rgba(0,0,0,0.05);
    display: inline-block;
    position: relative;
    vertical-align: top;
    padding-right:100px;
    padding-bottom: 10px;
  &:nth-child(2){/*設定第二個區塊與第一第三的距離原50*/
     margin: 0 50px;
   }
   &:nth-child(4){
     margin: 0 50px;/*設定第四個區塊與第三第五的距離原50*/
   }
   &:nth-child(6){
     margin: 0 50px;/*設定第六個區塊與第五的距離原50*/
   }



  .set-height{
    height: 100%;
    overflow-y: auto;
    &::-webkit-scrollbar{
      display: none;
    }
    -webkit-scrollbar:none;
    scrollbar-width:none;
  }
  img{
    height: 158px;
    max-width: 245px;
    background-size: 100%;
    position: absolute;
    top:-28%;
    left: 15px;
  }
  p{
    width: 508px;
    border-radius: 10px;
    display: inline-block;
    padding-left: 285px;
    padding-top: 22px;
    color: #000000;
    font-size: 18px;
    line-height: 32px;
    text-align: left;
  }
    .scroll-content{
      &::-webkit-scrollbar {
        width: 1px;
        height: 1px;
      }
    }
  }
  }
  .max-milestoneBox-100{
    div{
      max-width: 100%;
    }
  }
  .step-year{
    width: 100%;
    height: auto;
    padding:106px 0;
    ul{
      li{
        width:8%;/*滚动条里面年度距離-20250107:增加年度要調小這個值*/
        border-radius: 10px;
        float:left;

         .step-content{
           display: inline-block;
           font-size: 0;
           position: relative;
           width: 116%;
           padding-right: 10px;
           vertical-align: top;
           position: relative;
           .icon{
             width: 26px;
             height:26px;
             border-radius: 100%;
             border: solid 4px #fff;
             background-color: #fff;
             background-size: cover;
             background-position: center center;
             background-repeat: no-repeat;
             float: right;
             margin-bottom: 5px;
             position: relative;
           }
           &:before{
              display: block;
              content: "";
              height: 2px;
              width: 94%;
              background-color: #fff;
              position: absolute;
              left: 15px;
              top: 12px;
            }
            .year{
              color: #FFFFFF;
              font-size: 30px;
              font-style: italic;
              font-weight: 900;
              position: absolute;
              top: 55px;
              right: -14%;
            }
         }
        &.actived{
          width:8%;
           .step-content{
             .icon{
               border: 4px solid #FFFFFF;
               background-color: #F5AC2D;
             }
            &:before{
               height: 4px;
               background-color: #F5AC2D;
                left:0;
             }
           }

         }
        &:last-child{
          .step-content{
              &:before{
                  width: 233%;
               }
          }
         }
        &:nth-child(2n-1){
           .step-content{
             .year{
               top:-55px;
             }
           }
         }
      }
    }
  }
  .about-box-05{
    width: 100%;
    height: auto;
    background: url(../assets/images/aboutBg05.jpg) no-repeat center -149px;
    position: relative;
     padding-bottom:10px;/*調整與下一個區塊的距離*/
    .titleBox {
      h2{
        padding-left: 40px;
        margin-bottom: 13px;
      }
      .subtitle{
        .line{
          width: 164px;
        }
        .subtitle-font{
          color: #342112;
          font-size: 40px;
          letter-spacing: 3.33px;
          padding-left: 26px;
        }
      }
    }
    .titleBox2{
      margin-left: 28%;
    }
    .leftTop,.rightTop{
      width: 24%;
      display: inline-block;
      position: absolute;
      top: -265px;
      img{
        width: 100%;
        height: 100%;
        background-size: 100%;
      }
    }
    .leftTop{
      left: 0;
    }
    .rightTop{
      right:0;
    }
    .milestoneBox{
      margin-left: 13%;
      &>div{
        max-width: 739px;
        min-height: 216px;
        height: auto;
        display: block;
        margin: auto;
        margin-bottom: 88px;
        padding: 41px 28px 20px 24px;
        img{
          max-width: 267px;
          height: 216px;
          top: -40px;
          left: 20px;
          position: absolute;
        }
        .scroll-content{
          padding-left: 282px;
        }
        p{
          width: 100%;
          color: #2A1C15;
          font-size: 18px;
          letter-spacing: 1px;
          line-height: 32px;
          margin: 0;
          padding: 0;
          b{
            display: block;
            color: #2A1C15;
            font-size: 22px;
            font-weight: 500;
            letter-spacing: 1px;
            line-height: 32px;
            padding-bottom: 10px;
          }
        }
          /*設定第二個(偶數)區塊的格式?第三個區塊會連在一起先不使用*/
       /* &:nth-child(2){
          margin: 0;

          margin: auto;
        }*/
       }
    }

  }
  .text-pl-72{
   .subtitle{
      .line{
        width: 164px;
      }
       .subtitle-font{
         padding-left: 72px;
         padding-right: 40px;
       }
   }
  }
  .about-box-06{
    width: 100%;
    height: auto;
    background: url(../assets/images/aboutBg06.png) no-repeat center top;
    position: relative;
    margin-top: -190px;
     padding-bottom:250px;
    #top6{
      padding: 106px 5.8333% 0 7.6562%;
      .titleBox2{
        width: 30.7043%;
        margin-left: 0;
      }
      .corporateBox{
        width: 63.0945%;
        & > div{
          width: 100%;
          img{
            width: 72.519%;
            height: auto;
            max-width: 100%;
            top: auto;
            bottom: 52px;
            left: -52px;
          }
          .content{
            width: 27.4312%;
            padding: 0 5px 0 0;
            float: right;
          }
          button{
            width: 100%;
            max-width: 250px;
          }
          p{
            padding: 0;
            font-size: 18px;
            letter-spacing: 0.9px;
            line-height: 32px;
            b{
              display: block;
              font-size: 22px;
              letter-spacing: 1.1px;
              padding-top: 70px;
              padding-bottom: 8px;
            }
          }
           .height-144{
             min-height: 140px;
           }
        }
      }
      .titleBox2{
        h2{
          margin-bottom: 15px;
        }
        &.color-white{
          .line{
            width: 164px;
          }
        }
      }
      .text{
        font-size: 18px;
        letter-spacing: 1px;
        line-height: 32px;
      }

    }
    #top7{
      padding-top: 100px;
      overflow: hidden;
      padding: 100px 5.8333% 0 5.8333%;
      margin-left: 0;
      margin-top:0;
      .left{
        /*width: 62.6179%;*/
        width: calc(100% - 635px);
        float: left;
      }
      .right{
        /*width: 35.0825%;*/
        width: 595px;
        float: right;
        .titleBox2{
          width: 100%;
          margin: 0;
        }
      }
      .titleBox {
        h2{
          margin-bottom: 15px;
        }
        .subtitle {
          .subtitle-font{
            padding-left: 79px;
            padding-right: 40px;
          }
        }
      }
      .text{
        font-size: 18px;
        letter-spacing: 1px;
        line-height: 32px;
        margin-top: 50px;
      }
       .text22{
        font-size: 22px;
        color:white;
        letter-spacing: 1px;
        line-height: 32px;
        margin-top: 50px;

      }
    }
    #top8{
      padding-top: 200px;
      margin-left:
       0;
      .text-pl-72 {
        .subtitle{
          .subtitle-font{
            padding-left: 243px;
            padding-right: 25px;
          }
        }
      }
    }
    .titleBox2{
      width: 28%;
      margin-left:6%;
      display: inline-block;
      padding-top: 150px;
      .text{
         width: 100%;
        color: #FFFFFF;
        font-size: 18px;
        text-align: justify;
        margin-top: 40px;
      }

    }
     .titleBox3{
       width: 100%;
       margin-left:0;
       padding-top: 0;
       text-align: center;
     }
     .corporateBox{
       width: 60%;
       display: inline-block;
       vertical-align: text-bottom;
       text-align:left;
       padding-left: 5%;
       div{
         max-width: 1048px;
         min-height:390px;
         img{
           max-width:560px;
           height: 506px;
           top: -36%;
           left: -35px;
         }
         p{
           /*width: 830px;
           padding-left:568px;*/
           width: 100%;
           padding-left: 0;
           display: block;
         }
         .content{
           width: 830px;
           height: 100%;
           padding-left:568px;
           position: relative;
           float: right;
         }
         button{
           height: 60px;
           width: 250px;
           border-radius: 35px;
           background-color: #F5AC2D;
           font-size: 20px;
           font-weight: 500;
           letter-spacing: 1.5px;
           line-height: 32px;
           text-align: center;
           border: none;
           position: absolute;
           bottom: 58px;
           outline: none;
         }
       }
     }
     .about-Corporate{
       margin-left: 6%;
       padding-top:100px;
       .left{
          width: 58%;
         display: inline-block;
         vertical-align: top;
         img{
           width: 100%;
           height: 100%;
           background-size: 100%;
           margin-top: 26px;
         }
       }
       .right{
         width: 40%;
         display: inline-block;
         .titleBox2{
           width:80%;
         }
       }
      .moreLink{
        margin-top: 50px;
        a{
          display: inline-block;
          width: 140px;
          color: #FFFFFF;
          font-size: 20px;
          font-weight: 500;
          background: url("../assets/images/moreIphone.svg") no-repeat -12px bottom;
          background-size: 100% auto;
          padding-bottom: 35px;
          letter-spacing: 1.25px;
        }
      }
     }
     .container-box{
       width: 86.927%;
       height: auto;
       position: relative;
       margin: auto;
       .swiper-milestoneBox{
         margin-top: 15px;
         .milestoneBox{
           div{
             position: relative;
             padding: 0 23px;
             width: 100%;
             height: 100%;
             box-shadow: none;
             &.swiper-slide{
               height: 230px;
               padding: 0;
             }
             &.content{
               position: absolute;
               top: 0;
               right: 23px;
               width: calc(60% - 69px);
               padding: 30px 0;
               overflow: auto;
               border-radius: 0;
               &::-webkit-scrollbar {
                 width: 1px;
                 height: 1px;
               }
             }
             h3{
               color: #261A16;
               font-size: 22px;
               font-weight: 500;
               letter-spacing: 1px;
               line-height: 25px;
               text-align: left;
               margin-bottom: 10px;
             }
             .img-box{
               width: 40%;
               position: absolute;
               left: 23px;
               bottom: 24px;
               overflow: hidden;
               padding: 0;
               img{
                 position: static;
                 width: 100%;
                 height: 225px;
               }
             }
             p{
               width: 100%;
               height: auto;
               color: #2A1C15;
               font-size: 18px;
               letter-spacing: 1px;
               line-height: 32px;
               text-align: left;
               margin: 0;
               padding: 0;
             }
             &:nth-child(2){
               margin: 0;
             }
           }
         }
       }
        .swiper-button-next, .swiper-button-prev{
          margin-top: 22px;
        }
        .swiper-button-prev{
          left: -50px;
        }
        .swiper-button-next{
          right: -50px;
        }
     }
  }
  .en-font{
    .en-description{
      text-align: left !important;
      font-size: 16px !important;
      letter-spacing: 0 !important;
    }

  }
  @media (max-width:1560px){
/*    .aboutUs .top-img .info-box .title-box{
       h2{
         font-size:60px;
       }
       h3{
         font-size:28px;
       }
    }*/
  }

  @media (max-width:1360px){
  /*  .aboutUs .top-img .info-box{
       .title-box{
        bottom: 24%;
          h2{
            font-size:50px;
          }
          h3{
            font-size:26px;
          }
       }
    }*/
  }
  @media (max-width:1080px){
/*    .aboutUs{
      .top-img{
        height: 168px;
        background-image: url("../assets/images/aboutUs-mobile.png");
        background-color: rgb(250,250,250);
        background-size: cover;
        .info-box {
          height: 100%;
          .title-box{
            width: 100%;
            text-align: right;
            padding-top: 55px;
            h2, h3{
              font-size: 20px;
              line-height: 1.2;
            }
          }
        }
      }
    }*/
    .about-box-01 .right .img{
      margin:0 auto;
    }

    .product-title{
      padding: 0 10px 26px 7px;
    }
    .type-nav{
      width: 100%;
      margin-left: 0;
      select{
        background-image: url("../assets/images/angle-left-solid.png");
        background-size: 37px auto;
      }
    }
    .about-main-bg{
      background-size: 100% auto;
      background-image: url("../assets/images/product-bg-mobile.png");
      background-position: center 227px;
    }
    .about-main{
      padding: 50px 10px 0;
      background: none;
      .about-conten{
        padding: 0;
      }
    }
    .titleBox {
      text-align: center;
      h2{
        width: 100%;
        padding: 0;
        font-size: 22px;
        line-height: 50px;
        letter-spacing: -0.37px;
      }
      .subtitle {
        .subtitle-font{
          font-size: 22px;
          letter-spacing: 1.22px;
          line-height: 1;
          vertical-align: middle;
          padding-left: 5px;
        }
        .line{
          width: 30px;
          vertical-align: middle;
        }
      }
    }
    .about-box-01 {
      padding: 0 10px;
      .left{
        width: 100%;
        padding: 0;
        .description{
          padding: 35px 18px;
          color: #342112;
          font-size: 15px;
          letter-spacing: 0.5px;
          line-height: 28px;
          h3{
            font-size: 16px;
            font-weight: 500;
            letter-spacing: 0.53px;
            line-height: 28px;
            margin-bottom: 10px;
          }
          p{
            font-size: 15px;
            letter-spacing: 0.5px;
            line-height: 28px;
          }
        }
      }
      .right{
        width: 100%;
        margin: 45px 0 25px;
        &.pc_hide{
          display: block;
        }
        &.mobile_hide{
          display: none;
        }
      }
    }
    .about-box-02 {
      padding: 0 17px 50px;
      .titleBox{
        margin: 0 0 35px;
        padding-top: 20px;
      }
      .left{
        width: 100%;
        padding: 0;
        .img{
          max-width: 100%;
          width: 100%;
          margin: 0;
          height: auto;
          margin-bottom: 25px;
        }
        .description{
          max-width: 100%;
          width: 100%;
          margin: 0;
          color: #2F1E14;
          font-size: 15px;
          letter-spacing: 0.5px;
          line-height: 28px;
          p{
            font-size: 15px;
            letter-spacing: 0.5px;
            line-height: 28px;
          }
        }
      }
    }
    .about-box-03 {
      .titleBox {
        margin-bottom: 32px;
      }
      .left {
        .description{
          padding: 25px 17px;
          height: auto;
          color: #2A1C15;
          font-size: 15px;
          letter-spacing: 0.5px;
          line-height: 28px;
          p{
            color: #2A1C15;
            font-size: 15px;
            letter-spacing: 0.5px;
            line-height: 28px;
          }
        }
      }
      .right{
        position: static;
        padding: 0 28px;
        .img{
          height: auto;
          border-radius: 30px;
          overflow: hidden;
        }
      }
    }
    .about-box-04 {
      padding-bottom: 57px;
      width: calc(100% + 20px);
      margin-left: -10px;
      .titleBox2{
        margin: 0;
        padding-top: 120px;
      }
      .content-scroll{
        width: 100%;
        overflow: auto;
      }
      .content-box{
        width: 3200px;/*滚动条區塊寬度*/
      }
      .milestoneBox {
        padding-left: 15px;
        div{
          width: calc(33% - 40px);
          min-height: 105px;
          img{
            width: 44.77%;
            height: auto;
            bottom: 23px;
            top: auto;
          }
          p{
            width: 100%;
            padding-left: 60.77%; //手機版里程碑文字與圖片的距離
            font-size: 15px;
            letter-spacing: 0.5px;
            line-height: 28px;
          }
        }
      }
    }
    .step-year {
      padding: 75px 0;
      ul {
        li {
          width: 10%;/*滚动条里面年度距離*/
          &.actived{
            width: 175px;
          }
          .step-content {
            width: 100%;
            padding-right: 0;
            .year {
              font-size: 20px;
            }
            &:before{
              width: 100%;
              left: 0;
            }
          }
        }
      }
    }
    .titleBox2{
      margin: 0;
    }
    .about-box-05 {
      background: none;
      padding: 0 20px;
      position: relative;
      padding-bottom:130px;/*調整與下一個區塊的距離*/
      z-index: 1;
      .milestoneBox{
        margin: 0;
        div {
          padding: 0 20px 30px;
          height: auto;

          margin-bottom: 63px;
          max-width: 100%;
          img{
            width: 100%;
            max-width: 100%;
            height: auto;
            position: relative;
            top: -30px;
            left: 0;
          }
          p{
            width: 100%;
            padding: 0;
            font-size: 15px;
            letter-spacing: 0.5px;
            line-height: 28px;
            b{
              display: block;
              width: 100%;
              font-size: 16px;
              font-weight: 500;
              letter-spacing: 0.5px;
              line-height: 32px;
              text-align: center;
              padding-bottom: 10px;
            }
          }
        }
      }
    }
    .about-box-06 {
      background: none;
      padding-bottom: 0;
      #top6{
        padding: 310px 20px 0;
        width: calc(100% + 20px);
        background: url("../assets/images/aboutBg06-mobile.png") no-repeat center top;
        margin-left: -10px;
        margin-top: -230px;
        background-size: 100% 80%;
        .titleBox2{
          width: 100%;
          margin: 0;
          padding: 0 24px;
          .text{
            font-size: 15px;
            letter-spacing: 0.5px;
            line-height: 25px;
            margin-top: 39x;
          }
        }
        .corporateBox{
          width: 100%;
          padding-left: 0;
          div {
            width: 100%;
            height: auto;
            padding: 0 10px;
            img{
              width: 100%;
              position: relative;
              height: auto;
              top: -44px;
              left: 0;
            }
            .content{
              padding: 0 50px 47px;
              width: 100%;
              position: relative;
              p{
                font-size: 15px;
                letter-spacing: 0.5px;
                line-height: 28px;
                padding: 0;
                b{
                  font-size: 16px;
                  font-weight: 500;
                  letter-spacing: 0.5px;
                  line-height: 32px;
                  padding-bottom: 10px;
                }
              }
              .height-144{
                min-height: auto;
              }
            }
            button{
              position: static;
              width: 220px;
              height: 45px;
              font-size: 16px;
              font-weight: 500;
              letter-spacing: 1.2px;
              margin: 25px auto 0;
              display: block;
            }
          }
        }
      }
    }
    .about-box-06 {
      .titleBox {
        .subtitle{
          text-align: center;
          .subtitle-font{
            padding: 0;
            &:before{
              content: "";
              height: 2px;
              width: 30px;
              display: inline-block;
              background: #fff;
              vertical-align: middle;
              margin-right: 8px;
            };
          }
        }
      }
      #top7{
        background: url("../assets/images/aboutBg06.png") no-repeat center top;
        padding: 0 10px;
        margin-left: 0;
        width: calc(100% + 20px);
        margin-left: -10px;
        padding: 0;
        .left{
          width: 100%;
          margin-bottom: 30px;
        }
        .right{
          width: 100%;
          .titleBox {
            text-align: center;
            padding-top: 0px;
            h2{
              width: 100%;
              padding: 0;
              font-size: 22px;
              font-style: italic;
              font-weight: 900;
              letter-spacing: -0.37px;
              line-height: 40px;
            }
            .subtitle {
              .subtitle-font{
                font-size: 22px;
                letter-spacing: 1.22px;
                line-height: 30px;
                vertical-align: middle;
                padding-left: 71px;
              }
              .line{
                width: 30px;
                vertical-align: middle;
              }
            }
            .text{
              font-size: 15px;
              letter-spacing: 0.5px;
              line-height: 25px;
              text-align: justify;
              padding: 0 41px;
            }

            .moreLink{
              text-align: right;
              padding-right: 50px;
             a{
                display: inline-block;
                width: 60px;
                color: #FFFFFF;
                background: url("../assets/images/moreIphone.svg") no-repeat -12px bottom;
                background-size: 100% auto;
                padding-bottom: 35px;
                font-size: 14px;
                font-weight: 500;
                letter-spacing: 0.88px;
                line-height: 32px;
                text-align: justify;
              }
            }
          }
        }
      }
      #top8,.potstickers-box{
        width: calc(100% + 20px);
        margin-left: -10px;
        padding: 0 10px;
      }
      #top8{
        background: rgb(208,7,23);
        margin-top: 0;
        padding-bottom: 100px;
        padding-top: 20px;
      }
      .container-box {
        .swiper-milestoneBox{
          margin-top: 27px;
          padding: 0 10px;
          .milestoneBox {
            div {
              height: auto;
              .img-box{
                width: 100%;
                height: auto;
                position: relative;
                top: -35px;
                left: 0;
                img{
                  max-width: 100%;
                  width: 100%;
                  height: auto;
                }
              }
              .content{
                width: 100%;
                height: auto;
                position: static;
                padding: 0 0 30px 0;
              }
              &.swiper-slide{
                height: auto;
              }
              .set-height{
                height: auto !important;
                padding-bottom: 20px !important;
              }
              h3{
                font-size: 16px;
                letter-spacing: 0.5px;
                line-height: 32px;
                margin-bottom: 7px;
              }
              p{
                font-size: 15px;
                letter-spacing: 0.5px;
                line-height: 28px;
              }
            }
          }
        }
        .swiper-button-prev,.swiper-button-next{
          box-shadow: 0 2px 58px 0 rgba(0,0,0,0.39);
          border-radius: 50%;
          outline: none;
        }
        .swiper-button-prev{
          left: 0;
        }
        .swiper-button-next{
          right: 0;
        }
      }
    }
    #top1{
      .left{
        margin-top: 25px;
        float: none;
        .description{
          margin-left: 0;
          margin-top: 10px;
          max-width: 100%;
        }
      }
      .right{
        float: none;
        padding: 0;
        margin-bottom: 0;
      }
      .titleBox {
        h2{
          margin: 0;
        }
      }
    }
    .about-box-02{
      width: calc(100% - 18px);
      margin: 52px auto 0;
      padding: 0 18px 40px !important;
      .titleBox{
        margin-bottom: 55px;
        h2{
          margin-bottom: 0;
        }
      }
    }
    #top2{
      padding-top:0;
    }

    #top3{
      padding-top:50px;
      width: calc(100% - 18px);
      .titleBox {
        margin-bottom: 50px;
        h2{
          margin-bottom: 0;
        }
        .subtitle{
          .line{
            width: 30px;
          }
          .subtitle-font{
            font-size: 22px;
            letter-spacing: 1.22px;
            padding-left: 5px;
          }
        }
      }
      .left {
        .description{
          margin-left: 0;
          max-width: 100%;
        }
      }
      .right{
        width: 100%;
        margin-bottom: 25px;
      }
    }

    #top4{
      margin-top: 20px;
    }

    #top5{
      margin: 35px auto 0;
      width: calc(100% - 18px);
      padding-right: 0;
      padding-left: 0;
      .titleBox {
        margin: 0;
        padding-top: 20px !important;
        h2{
          margin-bottom: 0;
        }
        .subtitle{
          .line{
            width: 30px;
          }
          .subtitle-font{
            font-size: 22px;
            letter-spacing: 1.22px;
            padding-left: 5px;
          }
        }
      }
      .milestoneBox{
        .scroll-content{
          width: 100%;
          padding-left:0;
        }
      }
    }

    .about-box-06 {
      #top6{
        .titleBox2{
          h2{
            margin-bottom: 0;
          }
          width: 100%;
        }
        .corporateBox{
          width: 100%;
          & > div {
            img{
              width: 100%;
              position: relative;
              left: 0;
              top: 0;
              margin-top: -54px;
              margin-bottom: 25px;
            }
            p {
              b{
                padding-top: 0;
              }
            }
          }
        }
      }
      #top7 {
        margin-top: 42px;
        .titleBox {
          h2{
            margin-bottom: 0;
          }
        }
        .left{
          width: 100%;
          margin-bottom: 10px;
        }
        .right{
          width: 100%;
        }
        .text{
          margin-top: 35px;
        }
      }
      #top8{
        .text-pl-72 {
          .subtitle{
            .subtitle-font{
              padding: 0;
            }
          }
        }
        .titleBox {
          h2{
            margin-bottom: 0;
          }
        }
        .container-box {
          .swiper-milestoneBox{
            margin-top: 0;
            .milestoneBox {
              & > div{
                padding: 0 18px;
                div{
                  padding: 0;
                }
              }
            }
          }
          .swiper-button-prev{
            left: 20px;
          }
          .swiper-button-next{
            right: 20px;
          }
        }
      }
    }
  }
  @media (max-width: 1440px) {
    .about-box-02{
      padding: 0 44px 0 0;
    }
  }
  .set-scroll{
    .scroll-content{
      min-height: 135px;
    }
  }
  .rest-board{
    height: auto !important;
    padding-bottom: 30px !important;
    button{
      position: unset !important;
      margin-top:20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/aboutUs.vue